// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__24OY8","box":"WorkspacesBox_box__f5M3c","node":"WorkspacesBox_node__aiYCb"};